import {Tr} from "@/i18n/i18n";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class GenderChangePanel extends HorizontalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, firstAttempt: boolean, price: number, onAcceptCallback: () => void) {
        super(scene, canvas, Tr('smena.pola'));

        this.setDepth(3000);

        let clickSound = SoundUtils.addSound(scene, Keys.SOUND_BUTTON_CLICK);

        let title = TextUtils.addTextByFamily(scene, Tr('vi.pitaetes.smenit.pol.vashego.personazha'),
            0, -110, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let confirmation = TextUtils.addTextByFamily(scene, "",
            0, 40, '#ffd465', 16, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        if (firstAttempt) {
            let info = TextUtils.addTextByFamily(scene, Tr('pervaja.smena.oboydetsja.besplatno') + price,
                0, title.getBottomCenter().y! / CU.S + 60, '#716f6a', 15, 'normal', 450, Fonts.MYRIADPRO_BOLD);

            let iconInfo = SpriteUtils.addImage(scene, info.getBottomRight().x! + 35, info.y + 6, Keys.IMG_REWARD_GEM, undefined, 0.6);

            confirmation.setText(Tr('smenit.besplatno'));

            this.add([info, iconInfo]);
        } else {

            confirmation.setText(Tr('smenit.za') + price);
            confirmation.x -= 20;
            confirmation.y -= 40;

            let iconConfirmation = SpriteUtils.addImage(scene, confirmation.getBottomRight().x! + 35 * CU.S, confirmation.y, Keys.IMG_REWARD_GEM, undefined, 0.7);

            let questionMark = TextUtils.addTextByFamily(scene, " ?",
                iconConfirmation.getRightCenter().x! + 5, confirmation.y - 4, '#ffd465', 16, 'normal', 450, Fonts.MYRIADPRO_BOLD);

            this.add([iconConfirmation, questionMark]);
        }

        let acceptButton = new SquareButton(scene, 0, 135, 0, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('da'), false, 80, 80);

        acceptButton.setCallback(() => {
            SoundUtils.play(clickSound);
            if (onAcceptCallback != null) {
                this.close();
                onAcceptCallback();
            }
        });

        this.add([title, confirmation, acceptButton]);
    }


}
